import { Stack } from '@mui/material';
import React from 'react';

import { ChildLocationProps } from './ChildLocation.props';
import { ChildLocationDelete, NameWrapper, StyledTypography } from './ChildLocation.styles';
import { FontStyleProps } from '../../../@types';
import { COLORS } from '../../../configs/colors';
import { GRID_SPACING } from '../../../configs/ui-constants';
import { TextField } from '../../atoms/TextField';
import { ToogleButtonTextAlignment } from '../../atoms/ToogleButtonGroup';
import { TypographyVariantProps } from '../../atoms/Typography';

export const ChildLocation: React.FC<ChildLocationProps> = ({
  value,
  structureTypes,
  selectedStructureType,
  disableInputs,
  onChange,
  onDelete,
  error
}) => {

  return (
    <Stack direction="row" spacing={GRID_SPACING} alignItems={ToogleButtonTextAlignment.Center}>
      <NameWrapper>
        <TextField
          label="Node Name"
          required
          value={value?.name}
          onChange={(text: string) => onChange({
            ...value,
            name: text
          })}
          InputLabelProps={{ shrink: true }}
          error={value?.isDuplicate || (!!error && !value?.name)}
          helperText={error && !value?.name? error : value?.isDuplicate ? 'Duplicate node name' : undefined}
          disabled={!selectedStructureType || disableInputs}
        />
      </NameWrapper>
      {structureTypes?.find((type) => type.value === selectedStructureType)?.hasReferenceNumbers ?
        <>
          <TextField
            label="Ref 1"
            value={value?.reference1}
            onChange={(text: string) => onChange({
              ...value,
              reference1: text
            })}
            InputLabelProps={{ shrink: true }}
            disabled={!selectedStructureType || disableInputs}
          />
          <TextField
            label="Ref 2"
            value={value?.reference2}
            onChange={(text: string) => onChange({
              ...value,
              reference2: text
            })}
            InputLabelProps={{ shrink: true }}
            disabled={!selectedStructureType || disableInputs}
          />
          <TextField
            label="Ref 3"
            value={value?.reference3}
            onChange={(text: string) => onChange({
              ...value,
              reference3: text
            })}
            InputLabelProps={{ shrink: true }}
            disabled={!selectedStructureType || disableInputs}
          />
        </>
        :
        selectedStructureType &&
        <Stack flex={1}>
          <StyledTypography fontStyle={FontStyleProps.Italic} variant={TypographyVariantProps.Body1} textColor={COLORS.Gray}>
            {`Structure type ${structureTypes.find((type) => type.value === selectedStructureType)?.label || ''} does not allow Reference fields`}
          </StyledTypography>
        </Stack>
      }
      <ChildLocationDelete onClick={onDelete} />
    </Stack>
  );
};